"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const AkDynamicTable = require("@atlaskit/dynamic-table").default;
exports.DynamicTable = ({ caption, rows, isLoading, isFixedSize, rowsPerPage, onSetPage, onSort, head, defaultSortKey, defaultSortOrder, emptyView }) => (React.createElement(AkDynamicTable, { defaultPage: 1, caption: caption, rows: rows, isLoading: isLoading, isFixedSize: isFixedSize, rowsPerPage: rowsPerPage, onSetPage: onSetPage ? onSetPage : () => { }, onSort: onSort ? onSort : () => { }, head: head, defaultSortKey: defaultSortKey, defaultSortOrder: defaultSortOrder, emptyView: emptyView }));
